import { useMemo } from 'react'
import { createFilter, Options } from 'react-select'
import { useIntl } from 'react-intl'
import _isEmpty from 'lodash/isEmpty'

import {
  DROPDOWN_PREFIX,
  StyledBreadcrumb,
} from 'components/DomainBreadcrumbs/styles'
import type { DropdownOption } from 'components/Input/Dropdown'
import { domainsSelectorMessages } from './messages'

const filterOption = createFilter({
  stringify: (option: DropdownOption) => option.label,
})

interface DomainsSelectorDropdownProps {
  handleChange: (dropdownIndex: number, newDomainId: string) => void
  /* List of subDomains/groups */
  options?: Options<DropdownOption>
  /* What place/index in whole Domains Navigation current dropdown takes */
  dropdownIndex: number
  defaultValue?: any
}

function DomainsSelectorDropdown(props: DomainsSelectorDropdownProps) {
  const { formatMessage } = useIntl()
  const onChange = (newValue: DropdownOption) => {
    props.handleChange(props.dropdownIndex, String(newValue.value))
  }

  const domainValue = useMemo(() => {
    return (
      !_isEmpty(props.options) &&
      props.options?.find((opt) => opt.value === props.defaultValue)
    )
  }, [props.defaultValue, props.options])

  return (
    <StyledBreadcrumb
      classNamePrefix={DROPDOWN_PREFIX}
      onChange={(option) => onChange(option as DropdownOption)}
      options={props.options}
      placeholder={formatMessage(domainsSelectorMessages.selectDomain)}
      filterOption={filterOption}
      value={domainValue || ''}
    />
  )
}

export default DomainsSelectorDropdown
